import { MiniContainer, SecondaryBtn, SectionWrapper } from '../../Components'
import { ImportantNewsSec, LastProjectsSec, MainHeaderSec, ServicesSection, WhyUsSec } from '../../Sections'
import './HomePage.css'



const HomePage = () => {
    return (
        <>        
            <MainHeaderSec />
            <div className='home-page'>
                <MiniContainer>
                    <SectionWrapper>
                        <ServicesSection />
                    </SectionWrapper>

                    
                    <SectionWrapper>
                        <ImportantNewsSec />
                        <SecondaryBtn path={"/News"}>
                            Show more
                        </SecondaryBtn>
                    </SectionWrapper>


                    <SectionWrapper>
                        <LastProjectsSec />
                        <SecondaryBtn path={"/Projects"}>
                            Show more
                        </SecondaryBtn>
                    </SectionWrapper>



                    <div>
                        <WhyUsSec />
                    </div>
                </MiniContainer>

            </div>
        </>
    )
}

export default HomePage